<template>
  <div v-if="staff?.practitionerLicenseURL" class="document-wrapper flex-between">
    <div class="d-flex align-items-center">
      <div class="flex-center" style="width: 2.25rem; height: 2.25rem; background-color: var(--ch-white); border-radius: 6px;">
        <PdfFileIcon />
      </div>

      <div style="margin-left: 0.875rem;">
        <h4 style="margin-bottom: 0; color: var(--ch-black-80); font-size: var(--font-sm); font-weight: 500; letter-spacing: -4%;">
          License of Practice
        </h4>
        <div v-if="staff?.licenseExpiry" class="info-note">
          <span>Expires </span>
          <span>{{ formatDate(staff.licenseExpiry as string) ?? '-' }}</span>
        </div>
      </div>
    </div>
    
    <a
      @click="emit('view')"
      :href="(staff.practitionerLicenseURL as string)"
      target="_blank"
      rel="noopener noreferrer"
      class="view-document ms-1"
      data-testid="view-staff-doc"
    >
      View
    </a>
  </div>

  <span style="color: var(--ch-black-80); font-size: var(--font-sm);" v-else>N/A</span>
</template>

<script setup lang="ts">
import { PdfFileIcon } from "@/components/svg";

import { formatDate } from '@/lib/utils';
import { IPractitioner } from '@/types';

defineProps<{ staff?: IPractitioner }>();

const emit = defineEmits(['view']);
</script>

<style scoped>
.document-wrapper {
  margin-top: 0.625rem;
  padding: 0.625rem 0.875rem;
  background-color: var(--ch-black-5);
  border-radius: 5px;
}

.document-wrapper .info-note {
  color: var(--ch-black-50);
  font-size: var(--font-xxs);
  font-weight: 300;
  font-family: 'Poppins', 'DM Sans', sans-serif;
  letter-spacing: -3%;
}

.document-wrapper .view-document {
  color: var(--ch-black);
  font-size: 0.8125rem;
  font-family: 'Poppins', 'DM Sans', sans-serif;
  text-decoration: underline;
  letter-spacing: -7%;
}

.document-wrapper .view-document:hover {
  transform: translateY(-0.5px);
  transition: all ease-in-out 0.2s;
}
</style>